// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const Location = createIcon(
  <path
    clipRule="evenodd"
    d="M5.52393 9.56283C5.52393 5.94785 8.4092 2.99121 12.0003 2.99121C15.5914 2.99121 18.4767 5.94785 18.4767 9.56283C18.4767 10.3255 18.2271 11.2285 17.8909 12.1246C17.5468 13.0417 17.0776 14.0395 16.5687 15.0203C15.5503 16.9831 14.3404 18.9395 13.5623 20.152C12.827 21.2976 11.1736 21.2976 10.4384 20.152C9.66019 18.9395 8.45037 16.9831 7.43194 15.0203C6.92304 14.0395 6.45379 13.0417 6.10973 12.1246C5.77357 11.2285 5.52393 10.3255 5.52393 9.56283ZM12.0032 11.438C13.2706 11.438 14.2981 10.4105 14.2981 9.14307C14.2981 7.87562 13.2706 6.84814 12.0032 6.84814C10.7357 6.84814 9.70825 7.87562 9.70825 9.14307C9.70825 10.4105 10.7357 11.438 12.0032 11.438Z"
    fillRule="evenodd"
  />,
);
